import { asDateString } from './member-update-payload.util';

/** Body for PATCH .../branches/:branchId/suppliers/:id (UpdateSupplierDto). */
export function buildSupplierUpdatePayload(
  supplier: object,
  modifiedBy?: string,
): Record<string, unknown> {
  const s = (supplier || {}) as Record<string, unknown>;
  const payload: Record<string, unknown> = {};

  if (s.name) payload.name = s.name;
  if (s.profile !== undefined && s.profile !== null) payload.profile = s.profile;
  if (s.email !== undefined && s.email !== null) payload.email = s.email;
  if (s.phone) payload.phone = s.phone;
  if (s.gender) payload.gender = s.gender;

  const createdDate = asDateString(s.createdDate);
  if (createdDate) payload.createdDate = createdDate;

  if (modifiedBy) payload.modifiedBy = modifiedBy;
  else if (s.modifiedBy) payload.modifiedBy = s.modifiedBy;

  return payload;
}

/** Body for POST .../branches/:branchId/suppliers (CreateSupplierDto). */
export function buildSupplierCreatePayload(
  supplier: object,
  options: { company?: string; branch?: string; createdBy?: string } = {},
): Record<string, unknown> {
  const s = (supplier || {}) as Record<string, unknown>;
  const payload: Record<string, unknown> = {};

  if (s.name) payload.name = s.name;
  if (s.phone) payload.phone = s.phone;
  if (s.email !== undefined && s.email !== null) payload.email = s.email;
  if (s.profile !== undefined && s.profile !== null) payload.profile = s.profile;
  if (s.gender) payload.gender = s.gender;

  const company = options.company ?? s.company;
  const branch = options.branch ?? s.branch;
  if (company) payload.company = company;
  if (branch) payload.branch = branch;

  const createdBy = options.createdBy ?? s.createdBy;
  if (createdBy) payload.createdBy = createdBy;

  return payload;
}
